import React from "react";
import { connect } from "react-redux";
import language from "../../language/index.js";
import { Table } from "../Table/index.js";
import { CSVLink } from "react-csv";
import exportPDF from "../../utils/exportPDF.js";
import { DeleteModal, Modal } from "../Modal/index.js";
import { defineRole } from "../../utils/handleAccessRoles.js";
import { getStorage } from "../../utils/storage.js";
import NewProfile from "./NewComponent.js";
import {
  deleteComponentsSeparation,
  fetchComponentsSeparation,
} from "../../utils/queries/production/components/index.js";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class Components extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await fetchComponentsSeparation(defaultLanguage, {
        page,
        limit,
        ...search,
      });

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page) {
    this.setState({ page }, () => {
      this.getData(true);
    });
  }

  handleLimitChange(limit) {
    this.setState({ limit, page: 1 }, () => {
      this.getData(true);
    });
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
        type: "link",
        onPress: (item) =>
          this.handleShowModal(
            "showModal",
            language[this.props.defaultLanguage].component,
            item
          ),
      },
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].expiration_value,
        key: "expirationValue",
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
      },
      {
        title: language[this.props.defaultLanguage].expiration_type,
        key: "expirationType",
      },
      {
        title: language[this.props.defaultLanguage].volume,
        key: "volume",
      },
      {
        title: language[this.props.defaultLanguage].max_volume,
        key: "maxVolume",
      },
      {
        title: language[this.props.defaultLanguage].storage_temperature,
        key: "storageTemperature.name",
      },
      {
        title: language[this.props.defaultLanguage].concentration,
        key: "concentration",
      },
      {
        title: language[this.props.defaultLanguage].product_type,
        key: "productType.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      const { data } = await fetchComponentsSeparation(defaultLanguage, {
        page,
        limit,
        type: "separation",
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { page, limit } = this.state;
    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await fetchComponentsSeparation(defaultLanguage, {
      page,
      limit,
      type: "separation",
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Blood Usage", headers, data);
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteComponentsSeparation(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      code: search || search !== "" ? search : undefined,
      page: 1
    });

    this.setState({
      searching: false,
    });
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={this.handleSearch.bind(this)}
          searching={this.state.searching}
          addSearchButton
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          showAdd
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].component
          )}
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange.bind(this)}
          headers={this.returnTableHeaders()}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "ComponentSeparationProfile",
                operation: "update",
              }),
              name: language[this.props.defaultLanguage].edit,
              onPress: (item) =>
                this.handleShowModal(
                  "showModal",
                  language[this.props.defaultLanguage].edit,
                  item
                ),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "ComponentSeparationProfile",
                operation: "delete",
              }),
              name: language[this.props.defaultLanguage].delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].delete_
              ),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewProfile
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selectedData}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.code}
            getData={this.getData.bind(this)}
          />
        </Modal>

        <CSVLink
          ref={this.csvDownload}
          filename={"Component Separation Profiles" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Components);
